import { Component, OnInit, Input, Output, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

import { Contact } from '../../../models/contact';

import { ContactService } from '../../../services/contacts/contact.service';
import { ContactStoreService } from '../../../services/contacts/contact-store.service';
import { NotyService } from '../../../services/common/noty.service';

declare var moment: any;

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss'],
  providers: [],
})
export class ContactFormComponent implements OnInit, OnChanges {
  /**
   * Contact id
   */
  @Input() contactId: number;

  /**
   * Save Success
   */
  @Output() saveSuccessEvent = new EventEmitter<object>();

  /**
   * Contact object
   */
  contact: Contact = new Contact();

  /**
   * Default form options
   * @type {any}
   */
  formOptions: any = {
    attorneys_for_select: [],
    genders: [],
    generational_qualifiers: [],
    honoraria: [],
    qualifiers: [],
  };

  /**
   * Indicates if form has been submitted atleast once
   * @type {boolean}
   */
  formSubmitted: boolean = false;

  /**
   * Indicates if form is submitting now
   * @type {boolean}
   */
  formSubmitting: boolean = false;

  /**
   * Inject dependencies
   * @param {ContactService} private contactService Service for contact resource
   * @param {NotyService}    private notyService    Service for UI notifications
   */
  saveSuccess: boolean = false;

  constructor(private contactService: ContactService, private contactStoreService: ContactStoreService, private location: Location, private notyService: NotyService, private router: Router) {
    this.contactService.formOptions().then((response_json) => (this.formOptions = response_json));
  }

  // Component lifecycle methods
  ngOnInit() {}

  /**
   * Called when component variables change
   * @param {SimpleChanges} changes Object with variables which have changed
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.contactId && changes.contactId.currentValue) this.loadContact();
  }

  // Component methods

  /**
   * Open previous page
   */
  back() {
    this.location.back();
  }

  /**
   * Load Contact for edit
   */
  loadContact() {
    this.contactService.edit(this.contactId).then((response_json) => {
      this.contact = response_json.contact;
      if (this.contact.dob) {
        let date: any = moment(this.contact.dob, 'MM-DD-YYYY');
        this.contact.dob_struct = { day: date.date(), month: date.month() + 1, year: date.year() };
      }
      if (this.contact.dod) {
        let date: any = moment(this.contact.dod, 'MM-DD-YYYY');
        this.contact.dod_struct = { day: date.date(), month: date.month() + 1, year: date.year() };
      }
    });
  }

  /**
   * Save contact
   */
  save(formValid: boolean) {
    this.formSubmitted = true;
    if(this.contact.honorarium_id && this.contact.qualifier_id)
      formValid = false;
    let notificationPosition: string = 'topRight';
    if (!this.contactId) notificationPosition = 'topCenter';
    if (!formValid) {
      this.notyService.notify('Please check the form again', 'warning', 5000, notificationPosition);
      return;
    }
    this.formSubmitting = true;
    if (this.contact.dob_struct && this.contact.dob_struct.year) this.contact.dob = `${this.contact.dob_struct.day}-${this.contact.dob_struct.month}-${this.contact.dob_struct.year}`;
    else this.contact.dob = null;
    if (this.contact.dod_struct && this.contact.dod_struct.year) this.contact.dod = `${this.contact.dod_struct.day}-${this.contact.dod_struct.month}-${this.contact.dod_struct.year}`;
    else this.contact.dod = null;
    this.contactService
    .save(this.contact)
    .then((response_json) => {
      this.formSubmitting = false;
      if (response_json.success) {
        this.saveSuccess = true;
        this.saveSuccessEvent.emit({status: this.saveSuccess});
        this.notyService.notify(response_json.text || 'Contact saved', 'success', 5000, notificationPosition);
        if (!this.contactId) this.router.navigateByUrl(`/contacts/${response_json.id}`);
        else {
          if (this.contactStoreService.contactShowComponent) this.contactStoreService.contactShowComponent.loadContact();
          if (this.contactStoreService.contactSidebarComponent) this.contactStoreService.contactSidebarComponent.loadContact();
        }
      } else this.notyService.notify(response_json.text || 'Error saving contact', 'error', 5000, notificationPosition);
    })
    .catch(() => {
      this.formSubmitting = false;
      this.notyService.notify('Error saving contact', 'error', 5000, notificationPosition);
    });
  }
}
